export const CONFIG = {
 host: 'https://api.virtueanalytics.com/api',  
 paymentUrl:'https://tech.virtueanalytics.com/v-stripe-dev/payment',
//host: 'https://tech.virtueanalytics.com/v-api',  
   // host2: 'https://tech.virtueanalytics.com/collegeROIData',  
   //providerId: "4c6e0de8-b80c-4548-8bb3-5a32deb14fc0", 
   //formId: '52b018bf-3736-4cdf-871d-0b45711dcb8b',
   //providerUniversityState:"Wisconsin",
   //providerUniversity:"Marquette University",
   //organizationName: "myMSE",
   faviconId: '', 
top5Decryption:'Z4U6xAb6FEH96IfHo+CRkPh09d+JCxEURvaU5l+yAEtgDQZ+LZBI7YRePmRuM9F7fNDMQCLcSlJ7rvjLijubbB143fEEvUSK1JGAglaQboa/KYR+KHqr8ep5yp9CMYoKdA/MW96mRhLRuaMX5mfFFi1YoomhhBMNS9v2wT5py5mW9Nu8UH2DMhr1rKoFjLkkXaFBdHfJ+lN1WlVytKEgrJfIN7auYDx8buhqqUa2mM+Du1X2mPBeuuen9LGwOYPj8wTIiMtEDcN4gE8wwHVFFtstk6vX3UF34noHTurWzO2GiEU8vZfgqqYs8v/TxFQA4h09BdmAvWeiuxUu9vJ4H9gYfhWU6rw+jF6sZEmwHtdqksurcO2RYqBFly0t0AEvvFVHygBBXcGa602lxXBKx4j5nbXqn5xiA0LjV2bX7TTwN0WyV3lSgNIMK7jhO2mZbkeFOtdIwXPISUJnNBgkuBwvZOLy90NRZ/MNMeuW5RhfMvxAxikQKacR740BQPUEjcQVDAcJ5YDNTfMTSbcoxJ644jUzqeGGd/npxsvuihM9Kj+jYPd5DZ5y9Xtq4Iphh5NdOQq/8mZyIZ4JEzYAjX8YmH04x4LX5bl11yFwmg88GGFjVnzHpfd+vMynim2JTYNiIHgOEFJ3qZwZUVsCN4YIsXwoqaDDUbbG3rjK5ZGJ+Kx2+f2Dw8eIAzNG2i3QdMx7OjO8EgexSewRp1C35QW1WG2I7KPB0KW4Ym8dKKu8ZAwFNZmbyNz/FJh4q5k9PP7+jM5DpbQrEHPGPcmcr0Nr1gTWbiZ+toCQssn92TabeOlOCJjfYrT7vgoMonFyvx0GD8cOxjCVwKBo1+P3qlt3LUnviifKHfEAqJ8vTgCxOeKEOwUt9Y7v1fPLz7WSuKWWY4WnB4e3ZgX8w9IXEKVroGjpdD7hKwFriHze9hw='
   ,baseUrl: '', 
   logoUrl: '', 
   uiConfig: {}, 
   providerId: '', 
   formId: '',
   SERVICE_URL:'',
   USE_START_AT: null,
   organizationName: '',
   providerUniversityState:{},
   providerUniversity:{},
   REGEX: {
      "ALL_NUMBERS": '[^0-9]',
      "ALL-CHAR": '[^a-zA-Z ]',
      "ALL-CHAR-With-DOT": '[^a-zA-Z. ]',
      "EMAIL":'^[a-zA-Z0-9._+-]+@([a-zA-Z0-9]+\.[a-zA-Z]{2,4})$',
      "PHONE_FORMAT_old": '^(\\d{3})(\\d{3})(\\d{4})$',
      "PHONE_FORMAT": "(\\d{0,3})(\\d{0,3})(\\d{0,4})(\\d{0,4})",
      "ALL_NUMBERS_DECIMAL": '[^0-9.]'
   },

   minAge: 13,
   actLimit: { "min": 1, "max": 36 },
   cltLimit: { "min": 1, "max": 9 },
   satLimit: { "min": 650, "max": 1600 },


}

export let dropdownValues={}

export let GLOBAL = {
   RESULT_PAGE: {},
   FILE_UPLOAD_PAGE: {},
   STEPPER: {}
 }


